<div id="backdrop" *ngIf="show">
  <div class="loader">
    <fa-icon [icon]="faSpinnerThird" class="fa-spin" [spin]="true"></fa-icon>
  </div>
</div>
